import { t } from "i18next";
import { Suspense, lazy } from "react";

const LazyLoad = (path: string, t: (key: string) => string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<>{t("loading")}</>}>
      <Comp />
    </Suspense>
  );
};

const addPages = ["icp", "trademark", "industry", "others"];
const pageName:{[key: string]: string} = {
  main: "营业执照",
  icp: "ICP备案证明",
  trademark: "商标证",
  industry: "行业资质",
  others: "补充资质"
};
const updatePages = [...addPages, "main"];

const addRouters = addPages.map((page, index) => {
  return {
    path: `qualification/${page}/add`,
    element: LazyLoad(`Qualification/${page}`, t),
    name: pageName[page],
    key: "q_a_" + index + "_key",
    isHidden: true,
    fromPath: "/toolset/qualification",
    pathReg: /\/qualification\/[a-zA-Z]+\/add/,
  };
});

const updateRouters = updatePages.map((page, index) => {
  return {
    path: `qualification/${page}/update`,
    element: LazyLoad(`Qualification/${page}`, t),
    name: pageName[page],
    key: "q_d_" + index + "_key",
    isHidden: true,
    fromPath: "/toolset/qualification",
    pathReg: /\/qualification\/[a-zA-Z]+\/update/,
  };
});

export const QualificationPages = [...addRouters, ...updateRouters];
